//Allowed action list for form submit success event
export const AllowedList = ['leadBlock/createLead/fulfilled', 'extendedLeadBlock/createLead/fulfilled'];
//Action property in allowed list by index [leadBlock,extendedLeadBlock,..]
export const PropertyByActionIndex = ['leadFormTitle', 'title'];
export const ActionIsNotInList = -1;
